<template>
  <div style="margin: 10px">
    <el-form ref="ruleForm" label-position="right" :model="ruleForm" :rules="rules" label-width="160px">
      <el-form-item label="推荐人-工号：" prop="jobNumber">
        <el-input style="width: 100%" v-model="ruleForm.jobNumber" placeholder="被推荐人-工号" />
      </el-form-item>
      <el-form-item label="被推荐人-姓名：" prop="name">
        <el-input style="width: 100%" v-model="ruleForm.name" placeholder="被推荐人-姓名" />
      </el-form-item>
      <el-form-item label="被推荐人-部门：" prop="departmentName">
        <el-input style="width: 100%" v-model="ruleForm.departmentName" placeholder="被推荐人-部门："  @change="deptChange"/>
      </el-form-item>
      <el-form-item label="被推荐人-岗位：" prop="post">
        <el-select v-model="ruleForm.post" placeholder="请选择" clearable  filterable
                   style="width:100%">
          <el-option v-for="item in interviewPost" :key="item.id"
                     :label="item.jobName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="被推荐人-性别：" prop="sex">
        <el-radio-group v-model="ruleForm.sex">
          <el-radio :label="0">男</el-radio>
          <el-radio :label="1">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="被推荐人-邮箱：" prop="email">
        <el-input style="width: 100%" v-model="ruleForm.email" placeholder="被推荐人-邮箱" />
      </el-form-item>
      <el-form-item label="被推荐人-手机号码：" prop="phone">
        <el-input style="width: 100%" v-model.number="ruleForm.phone" maxlength="11" placeholder="被推荐人-手机号" />
      </el-form-item>
      <el-form-item label="被推荐人-最高学历：" prop="education">
        <el-select v-model="ruleForm.education" filterable clearable
                   placeholder="请选择(可手动输入搜索)" style="width:100%;">
          <el-option v-for="item in educationOptions" :key="item.itemCode" :label="item.itemName"
                     :value="item.itemCode" />
        </el-select>
      </el-form-item>
      <el-form-item label="被推荐人-英语等级：" prop="languageLevel">
        <el-select v-model="ruleForm.languageLevel" filterable clearable
                   placeholder="请选择(可手动输入搜索)" style="width:100%;">
          <el-option v-for="item in languageClassOptions" :key="item.itemCode" :label="item.itemName"
                     :value="item.itemCode" />
        </el-select>
      </el-form-item>
      <el-form-item label="附件上传：" prop="fileUrl">
        <el-upload
            ref="upload"
            :limit="1"
            list-type="picture"
            :data="uploadData"
            :action="`${baseUrl}/recruit/api/upload/file`"
            :on-success="handleUploadSuccess"
            :on-remove="handleRemove"
            :before-upload="handleBeforeUpload">
          <el-button style="text-align: left" size="small" type="primary"><i class="el-icon-upload"/> 点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div style="margin-top: 100px" slot="footer" class="dialog-footer">
      <el-button type="primary"  @click="confirm">确 定</el-button>
    </div>

  </div>
</template>

<script>
import { Message } from 'element-ui'


export default {
  name: "InternalRecommended",
  data() {
    return {
      rules: {
        jobNumber: [{required: true, message: "请输入工号", trigger: "blur"}],
        name: [{required: true, message: "请输入姓名", trigger: "blur"}],
        phone: [{required: true, message: "请输入手机", trigger: "blur"}],
        email: [{required: true, message: "请输入邮箱地址", trigger: "blur"}, {type: "email", message: "请输入正确的邮箱地址", trigger: ["blur", "change"]}],
        education: [{required: true, message: "请选择学历", trigger: "change"}],
        languageLevel: [{required: true, message: "请选择英语等级", trigger: "change"}],
        post: [{required: true, message: "请选择岗位", trigger: "change"}],
        departmentName: [{required: true, message: "请选择部门", trigger: "change"}],
        fileUrl: [{type: "array", required: true, message: "请上传附件", trigger: ["blur", "change"]}]},
      ruleForm: {name: "", post: "", departmentName: "", sex: 0, email: "", phone: "", education: "", languageLevel: "", fileUrl: []},
      interviewPost:[],
      languageClassOptions: [],
      educationOptions: [],
      uploadData: {
        userId:'',
        userName:'',
        uuid: "",
        moduleName: "t_interview_bole_award"
      },
    };
  },


  created() {
    this.getClassifyData();
  },

  computed: {

    baseUrl() {
      switch (this.$route.params.type) {
        case 'kingsold':
          return 'https://api.ksold.ltd';
        case 'homtran':
          return 'https://api.htran.ltd';
        case 'bessky':
          return 'https://api.ser.ltd:51443';
      }
    }
  },

  methods:{

    async getClassifyData() {
      ({data:{data:{list:[{items:this.educationOptions}]}}} = await this.$axios.post(`${this.baseUrl}/recruit/api/classifyList`, {page:{},query:{classifyCode:'Education'}}));
      ({data:{data:{list:[{items:this.languageClassOptions}]}}}  = await this.$axios.post(`${this.baseUrl}/recruit/api/classifyList`, {page:{},query:{classifyCode:'language_level'}}));
    },

    handleBeforeUpload(file) {
      this.uploadData.uuid = file.uid;
    },

    handleRemove() {
      this.ruleForm.fileUrl = []
    },

    handleUploadSuccess(res, file) {
      this.ruleForm.fileUrl = [{attachmentUrl: res.data.attachmentUrl, attachmentName: res.data.attachmentName}]
      this.$refs["ruleForm"].validate();
    },


   async deptChange(dept) {
     ({data:{data:{jobInformations:this.interviewPost}}} = await this.$axios.post(`${this.baseUrl}/recruit/api/jobInformation/list `, {query:{departmentName:dept}}))
    },

    confirm() {
      this.$refs["ruleForm"].validate(async valid => {
        if (valid) {
          let {data:{code,msg}} = await this.$axios.post(`${this.baseUrl}/recruit/api/interview/boleAward/create`, this.ruleForm);
          console.warn(msg)
          if (code === 200) {
            Message.success("投递成功！");
            this.$router.back()
          } else Message.error(msg);
        }
      });
    }



  }


}
</script>

<style scoped>
>>>.el-form-item__content{
  text-align: left;
}
</style>
